module.exports = "* {\n  position: absolute; }\n\n.s404 {\n  display: none !important; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/error/error.component.scss
// module id = ./src/app/error/error.component.scss
// module chunks = main